<template>
  <div class="main-body">
    <div class="header">子女列表</div>
    <div class="out">

      <div class="search2">

        <div style="float:right">

          <elSelectTree :options='zoneValue' accordion :props="zoneProps" v-if="zoneValue.length>0"
                        placeholder="请选择所属区域" v-on:getZoneValue="getZoneValue" :value='zoneCode'
                        style="width:200px;margin-right:10px"></elSelectTree>
          <el-button size="mini" type="primary" icon="el-icon-search" @click="getList">搜索</el-button>
        </div>

        <div style="clear: both;"></div>
      </div>


      <el-table class="table" size="mini" :data="tableData" :height="th" border>

        <el-table-column prop="userName" label="姓名"  fixed></el-table-column>

        <el-table-column prop="userPhone" label="手机"  fixed></el-table-column>

        <el-table-column label="状态">
          <template slot-scope="scope">
            <span v-if="scope.row.userStatus == 1">正常</span>
            <span v-if="scope.row.userStatus == 2">禁用</span>
          </template>
        </el-table-column>

        <el-table-column label="关联老人">
          <template slot-scope="scope">
            <div v-for="(item,index) in scope.row.listElderlyChildrenRelDTO" :key="index">
              <div>{{item.elderlyName}}({{item.relationName}})</div>
            </div>
          </template>
        </el-table-column>

<!--          <el-table-column fixed="right" label="操作" width="150">-->
<!--            <template slot-scope="scope">-->
<!--              <el-button size="mini" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>-->
<!--            </template>-->
<!--          </el-table-column>-->

      </el-table>

      <div class="page">
            <div style="float: left;">共{{totalItems}}条（{{Math.ceil(totalItems/pageSize)}}页）</div>
            <div style="float: left;">
              <el-pagination small
                  background
                  layout="prev, pager, next"
                  :total="totalItems"
                  :page-size="20"
                  :current-page.sync="currentPage"  @current-change="current_change">
              </el-pagination>
            </div>
            <div style="clear: both;"></div>
          </div>

    </div>


    <Add ref="myAdd" v-show="showModalAdd" v-on:closeAdd="closeAdd" v-on:getList="getList"></Add>
    <Edit ref="myEdit" v-show="showModalEdit" v-on:closeEdit="closeEdit" v-on:getList="getList"></Edit>

  </div>
</template>

<script>

import Add from "./Add";
import Edit from "./Edit";
import elSelectTree from "@/components/ElSelectTree"

import {timeStr} from "@/common/times";
import {getStaffCode} from "@/utils/auth";
import {hex_md5} from "@/common/Base64MD5";

export default {
  name: "Page",

  //注册局部过滤器
  filters: {
    timefilters(val) {
      if (val == null || val == "") {
        return "";
      } else {
        let d = new Date(val);   //val 为表格内取到的后台时间
        let month = d.getMonth() + 1 < 10 ? "0" + (d.getMonth() + 1) : d.getMonth() + 1;
        let day = d.getDate() < 10 ? "0" + d.getDate() : d.getDate();
        let hours = d.getHours() < 10 ? "0" + d.getHours() : d.getHours();
        let min = d.getMinutes() < 10 ? "0" + d.getMinutes() : d.getMinutes();
        let sec = d.getSeconds() < 10 ? "0" + d.getSeconds() : d.getSeconds();
        let times=d.getFullYear() + '-' + month + '-' + day + ' ' + hours + ':' + min + ':' + sec;
        return times;
      }
    }
  },

  data(){
    return{

      tableData:null,
      totalItems: 0,
      pageSize:20,
      currentPage:1,

      zoneProps: {
        emitPath: false,
        value: 'zoneCode',
        label: 'name',
        children: 'listZoneDTO'
      },
      //zoneCode:'00000000-0000-0000-0000-000000000000',
      zoneValue: [],
      zoneCode:'',

      showModalAdd:false,
      showModalEdit:false,
      roleList:null,
      editStaff:null,

      th:0,

    }
  },
  created(){
    this.getZoneList();
    this.th = this.$store.state.tableHeight;
  },
  components:{
    Add,Edit,elSelectTree
  },
  watch: {
    //监听全局变量
    '$store.state.tableHeight' : function(val){
      this.th = val;
    },
  },
  methods:{

    getZoneList:function (){
      this.$axios({
        method: 'post',
        url: this.$shopUrl + "Zone/ListForStaff",
        data: {
          timeStr: timeStr,
          sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
          staffCode: getStaffCode(),
        }
      }).then(
          (response) => {
            if (response.data.error == 0) {
              var data = JSON.stringify(response.data.data);
              data = JSON.parse(data.replace(/"listZoneDTO":\[\],/g, ''))
              this.zoneValue = data;
              //this.zoneCode=data[0].zoneCode;
              this.getList();

            } else if (response.data.error == 1) {
              this.$message({type: 'info', message: response.data.message});
            }
          }
      )
    },
    getZoneValue(val) {
      this.zoneCode = val
    },

    toggleModalAdd:function(){
      this.$refs.myAdd.init();
      this.showModalAdd = !this.showModalAdd;
    },
    closeAdd:function(){
      this.showModalAdd = !this.showModalAdd;
    },

    toggleModalEdit:function(){
      this.showModalEdit = !this.showModalEdit;
    },
    closeEdit:function(){
      this.showModalEdit = !this.showModalEdit;
    },
    roleNames(){
      return '管理员'
    },
    search(){
      this.currentPage = 1;
      this.getList();
    },

    getList(){
      this.$axios({
        method: 'post',
        url: this.$shopUrl+'Children/GovPage',
        data: {
          timeStr:timeStr,
          sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode: getStaffCode(),
          pageIndex:this.currentPage,
          pageSize:this.pageSize,
          zoneCode:this.zoneCode,
        }
      }).then( (response)=> {
        //console.log(response);
        if(response.data.error == 0){
          this.tableData = response.data.data.list;
          this.totalItems = response.data.data.total;
        }else if(response.data.error == 1){
          this.$message(response.data.message);
        }else{
          console.log(response.data.message);
        }

      }).catch(function (error) {
        console.log(error);
      });
    },

    current_change:function(currentPage){
      this.currentPage = currentPage;
      this.getList();
    },

    changeStatus:function(selVal){
      this.status = selVal;
    },


    deleteRow(index, rows) {
      rows.splice(index, 1);
    },
    handleEdit(index, row) {
      this.$refs.myEdit.init(row);
      this.showModalEdit = !this.showModalEdit;
    },
    handleDelete(index, row) {
      console.log(index, row);
    },


    statusTitle(row){
      if(row.status == 0){
        return "默认";
      }
      if(row.status == 1){
        return "已通过";
      }
      if(row.status == 2){
        return "被禁用";
      }
      return "其它";
    },


  }
}
</script>

<style scoped>

</style>
